import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './idb-project-table.css.lit';
import { idbLogo } from './project-logos';
import { unsafeSVG } from 'lit/directives/unsafe-svg.js';
import '../idb-styled-text/idb-styled-text';

/**
 * The IdbProjectTable component
 * @element idb-project-table
 * @slot - heading - The heading for the table
 * @slot - the default slot for adding idb-project-table-row components
 */
@customElement('idb-project-table')
export class IdbProjectTable extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <hr />
      
        <div class="heading-wrapper">
          <slot name="heading"></slot>
          <span class="logos-wrapper">
            ${unsafeSVG(idbLogo)}
          </span>
        </div>
        
        <div class="table-wrapper">
          <slot></slot>
        </div>
    `;
  }
}
